import Analytics from '@/singletons/analytics';
import SentrySingleton from '@/singletons/sentry-singleton';
import TextureStack from '@/singletons/texture-stack';
import * as THREE from 'three'

const RETRY_ATTEMPT_DELAY = 500

export default class TextureLoadService {
    private maxAnisotropy: number;
    private textureLoader: THREE.TextureLoader;

    constructor(maxAnisotropy: number) {
        this.maxAnisotropy = maxAnisotropy;
        this.textureLoader = new THREE.TextureLoader();
        this.textureLoader.setCrossOrigin("anonymous")
    }

    loadImage(path: string | null, callback: (tex: THREE.Texture | null) => void) {
        if (path === null || path === undefined) {
            callback(null);
            return;
        }
        if (this.getFileExtension(path) === null) {
            path += '.png';
        }
        // var fullPath = Settings.s48yeqb498 + "/" + texturesPath + path;
        var fullPath = 'lnxc5i9p4k/textures/' + path
        TextureStack.instance.add(fullPath)
        // this.textureLoader.load(fullPath, (tex) => {
        //     TextureStack.instance.remove(fullPath)
        //     this.prepareTexture(tex);
        //     callback(tex);
        // }, undefined, (error) => this.loadImage1Attempt(fullPath, callback))
        this.textureLoader.loadAsync(fullPath).then((tex) => {
            TextureStack.instance.remove(fullPath)
            this.prepareTexture(tex);
            callback(tex);
        }).catch((error) => this.loadImage1Attempt(fullPath, callback))
    }

    private getFileExtension(filename: string) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)![0] : null;
    }

    private prepareTexture(tex: THREE.Texture) {
        tex.flipY = false;
        tex.anisotropy = this.maxAnisotropy;
        tex.minFilter = THREE.LinearMipmapNearestFilter;
        tex.magFilter = THREE.LinearFilter;
        // tex.encoding = THREE.sRGBEncoding;       // need in old simulator ?
        tex.encoding = THREE.RGBEEncoding;
    }

    private loadImage1Attempt(fullPath: string, callback: (tex: THREE.Texture | null) => void) {
        setTimeout(() => {
            console.log("try reloading 1st attempt texture '" + fullPath + "'")
            // this.textureLoader.load(fullPath, (tex) => {
            //     console.log("reloading 1st attempt texture '" + fullPath + "' was successful")
            //     TextureStack.instance.remove(fullPath)
            //     this.prepareTexture(tex);
            //     callback(tex);
            // },
            //     undefined, (err) => this.loadImage2Attempt(fullPath, callback))

            this.textureLoader.loadAsync(fullPath).then((tex) => {
                console.log("reloading 1st attempt texture '" + fullPath + "' was successful")
                TextureStack.instance.remove(fullPath)
                this.prepareTexture(tex);
                callback(tex);
            }).catch((err) => this.loadImage2Attempt(fullPath, callback))
        }, RETRY_ATTEMPT_DELAY)
    }

    private loadImage2Attempt(fullPath: string, callback: (tex: THREE.Texture | null) => void) {
        setTimeout(() => {
            console.log("try reloading 2st attempt texture '" + fullPath + "'")
            // this.textureLoader.load(fullPath, (tex) => {
            //     console.log("reloading 2st attempt texture '" + fullPath + "' was successful")
            //     TextureStack.instance.remove(fullPath)
            //     this.prepareTexture(tex);
            //     callback(tex);
            // },
            //     undefined, (err) => this.loadImage3Attempt(fullPath, callback))
            this.textureLoader.loadAsync(fullPath).then((tex) => {
                console.log("reloading 2st attempt texture '" + fullPath + "' was successful")
                TextureStack.instance.remove(fullPath)
                this.prepareTexture(tex);
                callback(tex);
            }).catch((err) => this.loadImage3Attempt(fullPath, callback))
        }, RETRY_ATTEMPT_DELAY)
    }

    private loadImage3Attempt(fullPath: string, callback: (tex: THREE.Texture | null) => void) {
        setTimeout(() => {
            console.log("try reloading 3rd attempt texture '" + fullPath + "'")
            // this.textureLoader.load(fullPath, (tex) => {
            //     console.log("reloading 3rd attempt texture '" + fullPath + "' was successful")
            //     TextureStack.instance.remove(fullPath)
            //     this.prepareTexture(tex);
            //     callback(tex);
            // },
            //     undefined, (err) => this.loadImage4Attempt(fullPath, callback))
            this.textureLoader.loadAsync(fullPath).then((tex) => {
                console.log("reloading 3rd attempt texture '" + fullPath + "' was successful")
                TextureStack.instance.remove(fullPath)
                this.prepareTexture(tex);
                callback(tex);
            }).catch((err) => this.loadImage4Attempt(fullPath, callback))
        }, RETRY_ATTEMPT_DELAY)
    }

    private loadImage4Attempt(fullPath: string, callback: (tex: THREE.Texture | null) => void) {
        setTimeout(() => {
            console.log("try reloading 4th attempt texture '" + fullPath + "'")
            // this.textureLoader.load(fullPath, (tex) => {
            //     console.log("reloading 4th attempt texture '" + fullPath + "' was successful")
            //     TextureStack.instance.remove(fullPath)
            //     this.prepareTexture(tex);
            //     callback(tex);
            // },
            //     undefined, (err) => this.loadImage5Attempt(fullPath, callback))
            this.textureLoader.loadAsync(fullPath).then((tex) => {
                console.log("reloading 4th attempt texture '" + fullPath + "' was successful")
                TextureStack.instance.remove(fullPath)
                this.prepareTexture(tex);
                callback(tex);
            }).catch((err) => this.loadImage5Attempt(fullPath, callback))
        }, RETRY_ATTEMPT_DELAY)
    }

    private loadImage5Attempt(fullPath: string, callback: (tex: THREE.Texture | null) => void) {
        setTimeout(() => {
            console.log("try reloading 5th attempt texture '" + fullPath + "'")
            // this.textureLoader.load(fullPath, (tex) => {
            //     console.log("reloading 5th attempt texture '" + fullPath + "' was successful")
            //     TextureStack.instance.remove(fullPath)
            //     this.prepareTexture(tex);
            //     callback(tex);
            // }, undefined, (err) => this.onTextureError(err, fullPath))
            this.textureLoader.loadAsync(fullPath).then((tex) => {
                console.log("reloading 5th attempt texture '" + fullPath + "' was successful")
                TextureStack.instance.remove(fullPath)
                this.prepareTexture(tex);
                callback(tex);
            }).catch((err) => this.onTextureError(err, fullPath))
        }, RETRY_ATTEMPT_DELAY)
    }

    private onTextureError(err: ErrorEvent, fullPath: string) {
        console.error("error loading texture after 5 attempts: " + fullPath)
        console.error(JSON.stringify(err))
        TextureStack.instance.remove(fullPath)
        this.showSingleError(fullPath)
    }

    private showSingleError(fullPath: string) {
        try {
            const lastTime = parseInt(localStorage.getItem('errorReloadLastTime') ?? "0");
            const now = new Date().getTime();
            const timesince = now - lastTime;
    
            if (lastTime === undefined || (timesince > 30 * 1000)) {
                console.log("show alert")
                Analytics.instance.sendTextureLoadErrorEvent(fullPath)
                SentrySingleton.instance.captureMessage("error loading texture after 5 attempts")
                localStorage.setItem('errorReloadLastTime', new Date().getTime().toString());
                alert('データが正しくロードされませんでした。\nOKを押すとページを再読み込みします。')
                location.reload()
            }
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
        }
    }
}